import { render, staticRenderFns } from "./PositionTag.vue?vue&type=template&id=f4cedc0a&"
import script from "./PositionTag.vue?vue&type=script&lang=js&"
export * from "./PositionTag.vue?vue&type=script&lang=js&"
import style0 from "./PositionTag.vue?vue&type=style&index=0&id=f4cedc0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports